import React, { useState, useEffect } from 'react';
import { 
  Box,
  Typography,
  Button,
  Grid,
  TextField,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Tabs,
  Tab
} from '@mui/material';
import axios from 'axios';
import './SeleccionarProducto.css'; // Importamos el CSS

const apiUrl = process.env.REACT_APP_API_URL || "http://localhost:5002";

const SeleccionarProducto = ({ onSeleccion, onCancel, empleados = [] }) => {
  const [nuevoProducto, setNuevoProducto] = useState({ nombre: '', precio: '', duracion: 5 });
  const [productos, setProductos] = useState([]);
  const [tab, setTab] = useState(0);
  const [busqueda, setBusqueda] = useState('');

  const handleChangeTab = (event, newValue) => setTab(newValue);

  useEffect(() => {
    const fetchProductos = async () => {
      try {
        const response = await axios.get(`${apiUrl}/api/productos`);
        setProductos(response.data);
      } catch (error) {
        console.error("Error al cargar productos:", error);
      }
    };
    fetchProductos();
  }, []);

  const clasificarPorMarca = (marca) => {
    if (!marca) return 'otros';
    const m = marca.toLowerCase();
    if (m === 'icon') return 'icon';
    if (m === 'sweet') return 'sweet';
    return 'otros';
  };

  const filtrarProductos = (categoria) =>
    productos
      .filter(p => clasificarPorMarca(p.marca) === categoria)
      .filter(p => p.nombre_producto.toLowerCase().includes(busqueda.toLowerCase()));

  const handleBusqueda = (e) => {
    const valor = e.target.value;
    setBusqueda(valor);

    if (!valor) return; 

    const encontrado = productos.find(p =>
      p.nombre_producto.toLowerCase().includes(valor.toLowerCase())
    );

    if (encontrado) {
      const categoria = clasificarPorMarca(encontrado.marca);
      if (categoria === 'icon') setTab(0);
      else if (categoria === 'sweet') setTab(1);
      else setTab(2);
    }
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setNuevoProducto(prev => ({
      ...prev,
      [name]: value === "" ? "" : (name === 'precio' ? parseFloat(value) || "" : value)
    }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!nuevoProducto.nombre.trim()) return alert('El nombre es obligatorio');
    if (!nuevoProducto.precio || nuevoProducto.precio <= 0) return alert('Precio debe ser mayor a 0');

    const productoTratamiento = {
      id_tratamiento: 977749,
      id_producto: 999, // Productos manuales
      nombre_producto: nuevoProducto.nombre,
      precio: nuevoProducto.precio,
      duracion: 5,
      id_empleado: empleados.length > 0 ? empleados[0].id_empleado : null,
      esProducto: true
    };
    onSeleccion(productoTratamiento);
    setNuevoProducto({ nombre: '', precio: '', duracion: 5 });
  };

  return (
    <Box className="producto-form-container">
      
      {/* 🔹 Buscador y pestañas arriba */}
      <Typography className="producto-form-title">Productos del Inventario</Typography>
      <TextField
        fullWidth
        label="Buscar producto..."
        value={busqueda}
        onChange={handleBusqueda}
        className="producto-form-field"
      />
      <Tabs value={tab} onChange={handleChangeTab} aria-label="pestañas de marcas">
        <Tab label="ICON" />
        <Tab label="SWEET" />
        <Tab label="Otros" />
      </Tabs>
      <Box sx={{ mt: 2 }}>
        {tab === 0 && <ListadoProductos productos={filtrarProductos('icon')} empleados={empleados} onSeleccion={onSeleccion} />}
        {tab === 1 && <ListadoProductos productos={filtrarProductos('sweet')} empleados={empleados} onSeleccion={onSeleccion} />}
        {tab === 2 && <ListadoProductos productos={filtrarProductos('otros')} empleados={empleados} onSeleccion={onSeleccion} />}
      </Box>

      {/* 🔹 Agregar productos sin inventario */}
      <Box sx={{ mt: 4 }}>
        <Typography className="producto-form-title">Agregar Producto Nuevo</Typography>
        <Grid container spacing={2} alignItems="center">
          <Grid item xs={5}>
            <TextField
              fullWidth
              label="Nombre del Producto"
              name="nombre"
              value={nuevoProducto.nombre}
              onChange={handleChange}
              className="producto-form-field"
              required
            />
          </Grid>
          <Grid item xs={5}>
            <TextField
              fullWidth
              label="Precio (€)"
              name="precio"
              type="number"
              value={nuevoProducto.precio}
              onChange={handleChange}
              inputProps={{ min: 0.01, step: 0.01 }}
              className="producto-form-field"
              required
            />
          </Grid>
          <Grid item xs={12} sx={{ display: 'flex', justifyContent: 'flex-end', gap: 1 }}>
            <Button variant="outlined" onClick={onCancel}>Cancelar</Button>
            <Button variant="contained" onClick={handleSubmit}>Agregar Producto</Button>
          </Grid>
        </Grid>
      </Box>
    </Box>
  );
};

const ListadoProductos = ({ productos, empleados, onSeleccion }) => {
  const maxHeight = productos.length > 15 ? 400 : 'auto'; // scroll si hay más de 15 filas

  return (
    <TableContainer component={Paper} sx={{ mt: 2, maxHeight, overflowY: 'auto' }}>
      <Table stickyHeader>
        <TableHead>
          <TableRow>
            <TableCell>ID</TableCell>
            <TableCell>Línea</TableCell>
            <TableCell>Marca</TableCell>
            <TableCell>Nombre</TableCell>
            <TableCell>Precio (€)</TableCell>
            <TableCell>Cantidad</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {productos.map((p) => (
            <TableRow 
              key={p.id_producto} 
              hover
              sx={{ cursor: 'pointer' }}
              onClick={() => {
                const productoTratamiento = {
                  id_tratamiento: 977749,
                  id_producto: p.id_producto,
                  nombre_producto: p.nombre_producto,
                  precio: parseFloat(p.precio_producto),
                  duracion: 5,
                  id_empleado: empleados.length > 0 ? empleados[0].id_empleado : null,
                  esProducto: true
                };
                onSeleccion(productoTratamiento);
              }}
            >
              <TableCell>{p.id_producto}</TableCell>
              <TableCell>{p.linea || '-'}</TableCell>
              <TableCell>{p.marca || '-'}</TableCell>
              <TableCell>{p.nombre_producto}</TableCell>
              <TableCell>{p.precio_producto}</TableCell>
              <TableCell>{p.cantidad}</TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
};




export default SeleccionarProducto;
